<div class="bounds-shell">
  <!-- Header -->
  <div class="rounding-header">
    <span class="rounding-title">Upper and Lower Bounds</span>
    <dojo-button fill="outline" size="s" (click)="randomize()">
      <dojo-icon [icon]="'shuffle'" class="mr-1.5" />
      <span>Randomize</span>
    </dojo-button>
  </div>

  <!-- Controls -->
  <div class="controls-row">
    <div class="control-group">
      <label class="control-label">Number</label>
      <input
        class="number-input"
        type="text"
        [ngModel]="inputText()"
        (ngModelChange)="onInputChange($event)"
        placeholder="e.g. 2.6"
      />
    </div>
    <div class="control-group">
      <label class="control-label">Decimal places</label>
      <div class="dp-stepper">
        <button class="stepper-btn" (click)="onDpChange(dp() - 1)" [disabled]="dp() <= 0">-</button>
        <span class="dp-value">{{ dp() }}</span>
        <button class="stepper-btn" (click)="onDpChange(dp() + 1)" [disabled]="dp() >= 6">+</button>
      </div>
    </div>
  </div>

  <!-- Steps -->
  <div class="steps-section">
    <!-- Step 1: Degree of accuracy -->
    <div class="step">
      <div class="step-badge">1</div>
      <div class="step-content">
        <div class="step-title">Degree of accuracy</div>
        <div class="katex-line" [innerHTML]="degreeHtml()"></div>
      </div>
    </div>

    <!-- Step 2: Find bounds (visual diagram) -->
    <div class="step">
      <div class="step-badge">2</div>
      <div class="step-content">
        <div class="step-title">Find bounds</div>
        <div class="bounds-diagram">
          <!-- Row 1: half labels above connectors -->
          <span class="half-label left" [innerHTML]="minusHalfHtml()"></span>
          <span class="half-label right" [innerHTML]="plusHalfHtml()"></span>
          <!-- Row 2: LB ── value ── UB -->
          <span class="diagram-value lb" [innerHTML]="lbValueHtml()"></span>
          <span class="diagram-connector left"></span>
          <span class="diagram-value center" [innerHTML]="valueHtml()"></span>
          <span class="diagram-connector right"></span>
          <span class="diagram-value ub" [innerHTML]="ubValueHtml()"></span>
        </div>
        <div class="bound-labels">
          <span class="bound-label" [innerHTML]="lbTagHtml()"></span>
          <span class="bound-label" [innerHTML]="ubTagHtml()"></span>
        </div>
      </div>
    </div>

    <!-- Step 3: Answer -->
    <div class="step step-last">
      <div class="step-badge">3</div>
      <div class="step-content">
        <div class="step-title">Answer</div>
        <div class="katex-line katex-centered" [innerHTML]="answerHtml()"></div>
      </div>
    </div>
  </div>
</div>
